import classNames from 'classnames';
import React from 'react';
import * as styles from './BannerImageList.module.scss';
import Button from './Button';

export type DisplayMode = 'full' | 'grid';

interface BannerImageListButtonProps {
  onClick: () => void;
  src: string;
  alt: string;
}

export const BannerImageListButton = ({
  onClick,
  src,
  alt,
}: BannerImageListButtonProps) => {
  return (
    <Button className={styles.imageListButton} onClick={onClick}>
      <img alt={alt} className={styles.image} src={src} />
    </Button>
  );
};

export const BannerImageSkeleton = () => {
  return <div className={styles.skeleton} />;
};

interface BannerImagesListProps {
  displayMode: DisplayMode;
  children: React.ReactNode;
}

const BannerImageList = ({ displayMode, children }: BannerImagesListProps) => {
  return (
    <div className={classNames(styles.container, styles[displayMode])}>
      {children}
    </div>
  );
};

export default BannerImageList;
